// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type { NudgeRequest, NudgeResult } from '../types/nudge';

/**
 * Send a nudge email to the provider for a policy.
 *
 * <p>The previous {@code getNudgeData} fetch was removed when preview
 * defaults unified under {@code POST /api/email-preview} (see
 * {@link emailPreviewApi}); the send endpoint below is unchanged.
 */
export const sendNudge = async (policyId: string, request: NudgeRequest): Promise<NudgeResult> => {
  const response = await api.post<NudgeResult>(`/policies/${policyId}/nudge`, request);
  return response.data;
};

export default {
  sendNudge,
};
